<div class="ssl-checker mt-4">
  <div [formGroup]="formGroup">
    <input
      *ngIf="fields.fieldType === 'hidden'"
      type="hidden"
      [formControlName]="fields.fieldName"
    />
    <div class="search-wrapper" *ngIf="fields.fieldType == 'search'">
      <input
        type="text"
        #searchInput
        (input)="onKeyUpSearch(searchInput.value)"
        class="input w-full text-2sm p-2 border border-gray-300 rounded"
        [placeholder]="fields.placeholder"
      />

      <!-- Loader -->
      <div class="loader" *ngIf="isLoading"></div>
    </div>
    <div
      *ngIf="fields.fieldType !== 'hidden' && fields.fieldType != 'search'"
      class="w-full py-2"
    >
      <div
        class="grid grid-cols-12 gap-4 rounded-lg w-full max-w-md items-center mb-1"
      >
        <div class="col-span-3 md:col-span-6">
          <label for="text" class="block text-2sm font-medium text-dark">{{
            fields.displayName
          }}</label>
        </div>
        <div class="col-span-9 md:col-span-6">
          <input
            *ngIf="fields.fieldType != 'textarea'"
            [type]="fields.fieldType"
            [formControlName]="fields.fieldName"
            (input)="onKeyUpValidateFields(fields)"
            class="input w-full text-2sm p-2 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200 text-gray-700 placeholder:text-gray-500"
            [placeholder]="fields.placeholder"
            [ngClass]="{
              disabled: fields.fieldType == 'text',
              'is-invalid border-danger focus:ring-red-300':
                formGroup.get(fields.fieldName)?.touched &&
                formGroup.get(fields.fieldName)?.invalid
            }"
          />

          <!-- Show validation errors -->
          <div
            *ngIf="
              formGroup.get(fields.fieldName)?.touched &&
              formGroup.get(fields.fieldName)?.invalid
            "
            class="text-danger text-sm"
          >
            <div *ngIf="formGroup.get(fields.fieldName)?.errors?.['required']">
              Please enter {{ fields.displayName }}
            </div>
            {{ errors[fields.fieldName] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
